(function () {
  angular.module("akitabox.room.detail", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.router",
    "akitabox.core.services.room",
    "akitabox.core.services.recentActivity",
    "akitabox.core.toast",
    "akitabox.ui.dialogs.message.create",
  ]);
})();
